import React from "react";
import { ChakraProvider, Box } from "@chakra-ui/react";
import { ActiveLinkProvider } from "./ActiveLinkContext";
import Header from "../components/Header";
import Carousel from "../components/Carousel";
import SimpleService from "../components/SimpleService";
import MiniAbout from "../components/MiniAbout";
import PopularServices from "../components/PopularServices";
import BookNow from "../components/BookNow";
import MapEmbed from "../components/MapEmbed";
import Visit from "../components/Visit";
import Footer from "../components/Footer";

function Home() {
  return (
    <ChakraProvider>
      <ActiveLinkProvider>
        <Header />
        <Carousel />
        <SimpleService />
        <MiniAbout />
        <PopularServices />
        <BookNow />
        <Box
          bg={
            "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
          }
          height={"150px"}
        ></Box>
        <MapEmbed />
        <Visit />
        <Footer />
      </ActiveLinkProvider>
    </ChakraProvider>
  );
}

export default Home;
